var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 725.285,
    height: 785.542,
    viewBox: "0 0 725.285 785.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 725.285,
    height: 644.092,
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2934",
    "data-name": "Rectangle 2934",
    width: 389,
    height: 482,
    transform: "translate(-2105.725 -17990.361)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43739",
    "data-name": "Path 43739",
    d: "M477.127,380.345V396.3l23.939,9.119,18.809-1.709,3.419-7.41V377.495Z",
    transform: "translate(-477.127 -377.495)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.904,
    y1: 8.57,
    x2: -10.881,
    y2: 8.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0ac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2927",
    "data-name": "Rectangle 2927",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43741",
    "data-name": "Path 43741",
    d: "M466.6,349.241c.569,12.729,4.331,39.783,14.818,46.167,13.11,7.978,29.639,11.4,40.469,0s14.818-42.177,11.4-57c-2.736-11.854-45.788-17.29-66.687-18.809Z",
    transform: "translate(-466.601 -319.602)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.789,
    y1: 3.709,
    x2: -4.778,
    y2: 3.709,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2929",
    "data-name": "Rectangle 2929",
    width: 1098.362,
    height: 778.678,
    transform: "translate(-1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43749",
    "data-name": "Path 43749",
    d: "M461.876,336.371c-2.09.379-5.357,3.191-1.709,11.4,4.559,10.259,5.7,11.4,9.119,11.969,1.657.276,1.306-5.736-.144-11.75-1.418-5.88-3.886-11.76-6.557-11.759a1.888,1.888,0,0,0-.709.141",
    transform: "translate(-458.524 -336.23)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -28.382,
    y1: 14.434,
    x2: -28.32,
    y2: 14.434,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43750",
    "data-name": "Path 43750",
    d: "M523.345,347.989c-1.45,6.014-1.8,12.026-.143,11.75,3.42-.569,4.56-1.709,9.119-11.969,3.648-8.208.38-11.021-1.71-11.4a1.888,1.888,0,0,0-.709-.141c-2.672,0-5.14,5.879-6.558,11.759",
    transform: "translate(-522.101 -336.23)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -23.798,
    y1: 13.736,
    x2: -23.752,
    y2: 13.736,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83799",
    "data-name": "Group 83799",
    transform: "translate(-1124.001 -254.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83782",
    "data-name": "Group 83782",
    transform: "translate(-54.154 -110.9)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83673",
    "data-name": "Group 83673",
    transform: "translate(1178.155 507.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83672",
    "data-name": "Group 83672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43602",
    "data-name": "Path 43602",
    d: "M417.86,287.532c70.282-24.983,222.4,76.793,236.248-11.743s-98.214-87.65-76.808-174.975-68-146.434-133.471-54.551S298.4-10.434,145.253,61.336C1.057,128.912,24.532,401.429,244.164,398.684c92.776-1.159,118.025-91.362,173.7-111.153",
    transform: "translate(33.628 0)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43603",
    "data-name": "Path 43603",
    d: "M267.493,238.663c13.641-20.119,38.029-50.6,75.887-45.484S424.467,240,505.894,238.663,609.983,353.772,554.58,413.491,374.1,316.233,277.567,359.045,248.824,266.2,267.493,238.663",
    transform: "translate(140.292 119.071)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43605",
    "data-name": "Path 43605",
    d: "M69.369,106.9A34.685,34.685,0,1,1,34.685,72.22,34.684,34.684,0,0,1,69.369,106.9",
    transform: "translate(18.655 -42.353)",
    fill: "#e4e4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83669",
    "data-name": "Group 83669",
    transform: "translate(1451.467 613.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43586",
    "data-name": "Path 43586",
    d: "M.413,6.4,53.44,152.1c1.288,3.537,5.2,6.4,8.735,6.4H356.054c3.537,0,5.361-2.868,4.073-6.4L307.1,6.4c-1.287-3.537-5.2-6.4-8.735-6.4H4.486C.949,0-.875,2.867.413,6.4",
    transform: "translate(0 0.001)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43587",
    "data-name": "Path 43587",
    d: "M9.6,0h23.51a.857.857,0,0,1,.806,1.267L26.125,22.676A2,2,0,0,1,24.4,23.943H.887a.857.857,0,0,1-.805-1.266L7.874,1.267A2,2,0,0,1,9.6,0",
    transform: "translate(247.148 21.869) rotate(-30)",
    fill: "#95cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43588",
    "data-name": "Path 43588",
    d: "M2.808,17.279.078,11.618A1.458,1.458,0,0,1,.824,9.951l.2-.13c.652-.422,1.376-.36,1.617.139L4.2,13.189c.277.576,1.18.554,1.857-.044L20.406.463A1.308,1.308,0,0,1,22.144.244l.115.123c.373.4.2,1.141-.385,1.659L4.666,17.236c-.677.6-1.58.62-1.858.044",
    transform: "translate(254.532 21.281) rotate(-30)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43589",
    "data-name": "Path 43589",
    d: "M11.8,0H40.7a1.054,1.054,0,0,1,.99,1.557L32.11,27.871a2.464,2.464,0,0,1-2.124,1.557H1.091A1.054,1.054,0,0,1,.1,27.87L9.678,1.557A2.462,2.462,0,0,1,11.8,0",
    transform: "translate(282.829 121.602) rotate(-30)",
    fill: "#95cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43590",
    "data-name": "Path 43590",
    d: "M3.452,21.237.1,14.278a1.792,1.792,0,0,1,.917-2.049l.247-.16c.8-.519,1.692-.442,1.987.171l1.914,3.97c.341.708,1.45.681,2.282-.054L25.08.569A1.608,1.608,0,0,1,27.216.3l.142.151c.459.489.247,1.4-.474,2.039L5.735,21.184c-.833.735-1.942.762-2.283.054",
    transform: "translate(291.905 120.878) rotate(-30)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43591",
    "data-name": "Path 43591",
    d: "M196.9,28.34H334.261c.368,0,.533-.365.369-.815a1.2,1.2,0,0,0-.962-.814H196.309c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-119.596 -6.878)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43592",
    "data-name": "Path 43592",
    d: "M167.791,41.713h155.36c.368,0,.533-.365.369-.815a1.2,1.2,0,0,0-.962-.814H167.2c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-86.872 -10.32)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43593",
    "data-name": "Path 43593",
    d: "M162.924,55.086h155.36c.368,0,.533-.365.369-.815a1.2,1.2,0,0,0-.962-.814H162.332c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-78.391 -13.763)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43594",
    "data-name": "Path 43594",
    d: "M171.369,98.49h137.36c.367,0,.532-.365.368-.815a1.2,1.2,0,0,0-.962-.814H170.777c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-75.106 -24.938)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43595",
    "data-name": "Path 43595",
    d: "M142.259,111.863H297.62c.368,0,.533-.365.369-.815a1.2,1.2,0,0,0-.962-.814H141.667c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-42.382 -28.383)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43596",
    "data-name": "Path 43596",
    d: "M137.391,125.236h155.36c.368,0,.533-.365.369-.814a1.2,1.2,0,0,0-.962-.815H136.8c-.368,0-.532.365-.369.815a1.2,1.2,0,0,0,.962.814",
    transform: "translate(-33.899 -31.826)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43597",
    "data-name": "Path 43597",
    d: "M147.728,163.444H285.087c.368,0,.533-.365.369-.814a1.2,1.2,0,0,0-.962-.815H147.136c-.368,0-.532.365-.369.815a1.2,1.2,0,0,0,.961.814",
    transform: "translate(-33.91 -41.663)",
    fill: "#95cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43598",
    "data-name": "Path 43598",
    d: "M118.617,176.817h155.36c.368,0,.533-.365.369-.815a1.2,1.2,0,0,0-.962-.814H118.025c-.368,0-.532.365-.369.814a1.2,1.2,0,0,0,.962.815",
    transform: "translate(-1.185 -45.105)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43599",
    "data-name": "Path 43599",
    d: "M113.75,190.191H269.111c.367,0,.532-.365.368-.813a1.2,1.2,0,0,0-.962-.815H113.158c-.368,0-.532.364-.369.815a1.2,1.2,0,0,0,.962.813",
    transform: "translate(7.296 -48.55)",
    fill: "#cfe9ff",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43600",
    "data-name": "Path 43600",
    d: "M28.244,24.631,6.368,28.915A1.915,1.915,0,0,1,4.118,27.4l-1.6-8.147L2.3,18.119l-.626-3.206-.346-1.747L.036,6.575A1.92,1.92,0,0,1,1.549,4.321L23.426.036a1.921,1.921,0,0,1,2.254,1.513l4.077,20.829a1.919,1.919,0,0,1-1.513,2.254",
    transform: "translate(259.943 68.338) rotate(-30)",
    fill: "#95cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43601",
    "data-name": "Path 43601",
    d: "M6.462,19.862.7,15.126A1.92,1.92,0,1,1,3.139,12.16l2.172,1.785a1.92,1.92,0,0,0,2.905-.565L14.954,1a1.92,1.92,0,0,1,3.372,1.836L9.367,19.3a1.92,1.92,0,0,1-2.905.565",
    transform: "translate(266.158 69.491) rotate(-30)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2863",
    "data-name": "Rectangle 2863",
    width: 360.541,
    height: 158.5,
    transform: "translate(0 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43531",
    "data-name": "Path 43531",
    d: "M8.924,46.426a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5",
    transform: "translate(1204.299 351.391)",
    fill: "#80d6be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43532",
    "data-name": "Path 43532",
    d: "M14.336,46.426a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5",
    transform: "translate(1203.64 351.391)",
    fill: "#80d6be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43533",
    "data-name": "Path 43533",
    d: "M19.749,46.426a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5",
    transform: "translate(1136.96 286.797)",
    fill: "#80d6be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83670",
    "data-name": "Group 83670",
    transform: "translate(15.048 -89.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43535",
    "data-name": "Path 43535",
    d: "M185.166,514.714c-1.623-2.442-3.177-4.965-4.619-7.5l2.544-1.448c1.409,2.475,2.926,4.939,4.512,7.325Zm-8.7-15.3c-1.282-2.692-2.452-5.418-3.477-8.1l2.736-1.044c1,2.615,2.135,5.269,3.385,7.889Zm-6.257-16.486a87.336,87.336,0,0,1-1.972-8.624l2.883-.505a84.56,84.56,0,0,0,1.907,8.336ZM167.2,465.5c-.083-1.423-.126-2.859-.126-4.267,0-1.54.051-3.091.152-4.609l2.921.194c-.1,1.454-.146,2.939-.146,4.415,0,1.351.041,2.729.122,4.094Zm4.071-17.105-2.869-.582a65.519,65.519,0,0,1,2.355-8.575l2.764.967a62.515,62.515,0,0,0-2.25,8.19m5.582-16.013-2.613-1.32a72.675,72.675,0,0,1,4.49-7.655l2.432,1.631a69.722,69.722,0,0,0-4.309,7.344m9.434-14.237-2.305-1.806c1.758-2.244,3.591-4.539,5.448-6.819l2.27,1.848c-1.845,2.267-3.667,4.547-5.413,6.776m10.948-13.458L195,402.8c1.814-2.153,3.667-4.321,5.665-6.631l2.213,1.917c-1.99,2.3-3.835,4.457-5.639,6.6M208.6,391.547l-2.194-1.938q2.932-3.318,5.789-6.508l2.182,1.951q-2.849,3.184-5.778,6.495m11.58-12.977L218,376.618q2.953-3.3,5.78-6.492l2.194,1.938q-2.828,3.2-5.792,6.506m11.524-13.08-2.221-1.907c1.246-1.453,2.409-2.825,3.51-4.148q-1.171-.043-2.351-.112l.17-2.923c2.925.17,5.814.22,8.572.148l.077,2.926c-.9.025-1.811.032-2.729.033-1.547,1.884-3.2,3.849-5.029,5.982m16.56-6.662-.36-2.905a77.226,77.226,0,0,0,8.389-1.5l.679,2.847a80.222,80.222,0,0,1-8.708,1.562m-26.388-.346c-2.831-.375-5.749-.856-8.674-1.431l.565-2.873c2.866.563,5.723,1.035,8.493,1.4Zm-17.241-3.366c-2.919-.746-5.761-1.584-8.447-2.494l.939-2.773c2.615.885,5.385,1.7,8.233,2.431Zm60.819-.427-1.025-2.742a64.167,64.167,0,0,0,7.741-3.489l1.38,2.582a67.084,67.084,0,0,1-8.1,3.649m-22.726-2.78-2.339-1.761c1.847-2.451,3.483-4.746,5-7.015l2.432,1.629c-1.551,2.315-3.218,4.653-5.1,7.147m-54.768-2.489a79.524,79.524,0,0,1-7.884-4.033l1.481-2.526a76.607,76.607,0,0,0,7.594,3.884Zm93.123-3.1-1.72-2.369a62.879,62.879,0,0,0,6.515-5.447l2.024,2.114a65.572,65.572,0,0,1-6.819,5.7M172.721,340.4a56.065,56.065,0,0,1-6.567-6.037l2.151-1.986a53.208,53.208,0,0,0,6.223,5.72Zm79.738-3.125-2.549-1.439c1.454-2.575,2.746-5.143,3.841-7.634l2.679,1.179c-1.133,2.579-2.469,5.235-3.971,7.894m41.442-3.2-2.28-1.835a71.653,71.653,0,0,0,4.934-6.951l2.483,1.551a74.509,74.509,0,0,1-5.137,7.235m-133.208-6.8a46.736,46.736,0,0,1-4.047-8l2.729-1.063a43.763,43.763,0,0,0,3.791,7.5Zm98.807-6.215-2.806-.835a59.842,59.842,0,0,0,1.843-8.271l2.9.429a62.624,62.624,0,0,1-1.932,8.678m43.808-1.981-2.637-1.271a84.154,84.154,0,0,0,3.31-7.889l2.752,1a86.932,86.932,0,0,1-3.425,8.165m-149.1-8.428a50.468,50.468,0,0,1-.806-8.911l2.928-.007a47.526,47.526,0,0,0,.758,8.392ZM262.1,303.513l-2.927-.022,0-.567A66.808,66.808,0,0,0,258.7,295l2.907-.349a69.683,69.683,0,0,1,.489,8.276Zm47.225-1.071-2.838-.714a74.214,74.214,0,0,0,1.624-8.386l2.9.381a77.052,77.052,0,0,1-1.688,8.719M157.007,293.3l-2.89-.463a61.268,61.268,0,0,1,2.054-8.667l2.793.877a58.487,58.487,0,0,0-1.957,8.253m100.116-6.648a58.6,58.6,0,0,0-2.733-8.026l2.694-1.143a61.518,61.518,0,0,1,2.87,8.428Zm51.493-1.792a72.722,72.722,0,0,0-.559-8.5l2.906-.356a75.439,75.439,0,0,1,.58,8.841Zm-146.555-7.725-2.649-1.247a67.87,67.87,0,0,1,4.308-7.774l2.463,1.583a64.759,64.759,0,0,0-4.122,7.438m88.437-6.028a53.091,53.091,0,0,0-5.013-6.812l2.211-1.92a55.964,55.964,0,0,1,5.291,7.191Zm56.114-3.184c-.572-2.64-1.284-5.442-2.117-8.331l2.812-.811c.852,2.951,1.58,5.818,2.165,8.522Zm-135.363-5.05-2.225-1.9a59.9,59.9,0,0,1,6.271-6.336l1.918,2.212a56.967,56.967,0,0,0-5.963,6.025m68.193-4.482a50.546,50.546,0,0,0-6.929-4.814l1.464-2.535a53.546,53.546,0,0,1,7.331,5.094Zm-55.41-6.5-1.5-2.517a40.221,40.221,0,0,1,8.2-3.742l.9,2.788a37.2,37.2,0,0,0-7.6,3.472m117.859-.522c-.885-2.581-1.879-5.314-2.957-8.123l2.733-1.049c1.09,2.842,2.1,5.608,2.993,8.222Zm-77.019-1.394a52.8,52.8,0,0,0-8.131-2.307l.572-2.871a55.723,55.723,0,0,1,8.584,2.436Zm-25.024-3.1-.277-2.915a64,64,0,0,1,8.9-.23l-.133,2.925a60.837,60.837,0,0,0-8.486.22m95.869-11.667c-1.055-2.541-2.2-5.222-3.41-7.969l2.68-1.178c1.215,2.766,2.371,5.465,3.434,8.024Zm-6.969-15.88c-1.154-2.514-2.39-5.16-3.673-7.865l2.645-1.255c1.288,2.716,2.529,5.373,3.689,7.9Zm-7.437-15.691q-1.846-3.79-3.837-7.793l2.622-1.3q2,4.017,3.847,7.815Zm-7.656-15.662c-1.238-2.7-2.4-5.413-3.454-8.069l2.721-1.078c1.035,2.608,2.176,5.276,3.394,7.926ZM267.2,171.649c-.931-2.83-1.763-5.671-2.473-8.442l2.836-.726c.694,2.709,1.507,5.486,2.419,8.254ZM262.865,154.6c-.518-2.941-.91-5.885-1.163-8.747l2.916-.258c.246,2.78.626,5.638,1.13,8.5Zm1.405-17.553-2.927-.026a82.125,82.125,0,0,1,.551-8.838l2.908.343a78.941,78.941,0,0,0-.531,8.521m2.029-16.907-2.845-.689a68.446,68.446,0,0,1,2.643-8.482l2.731,1.053a65.5,65.5,0,0,0-2.528,8.118m6.119-15.813-2.559-1.421a61.5,61.5,0,0,1,4.871-7.454l2.327,1.775a58.821,58.821,0,0,0-4.639,7.1",
    transform: "translate(1105.272 369.783)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43536",
    "data-name": "Path 43536",
    d: "M300.576,89.311,298.552,87.2c1.085-1.038,2.218-2.042,3.372-2.984l1.853,2.265c-1.094.9-2.171,1.849-3.2,2.834",
    transform: "translate(1087.599 371.152)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83671",
    "data-name": "Group 83671",
    transform: "translate(6.597 -20.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43530",
    "data-name": "Path 43530",
    d: "M1.982,41.187H222.641V178.675H1.982ZM0,180.657H224.623V39.206H0Z",
    transform: "translate(1396.952 235.795)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2849",
    "data-name": "Rectangle 2849",
    width: 222.641,
    height: 1.982,
    transform: "translate(1397.943 289.059)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2850",
    "data-name": "Rectangle 2850",
    width: 59.692,
    height: 59.693,
    transform: "translate(1417.691 320.663)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2854",
    "data-name": "Rectangle 2854",
    width: 101.648,
    height: 1.982,
    transform: "translate(1495.982 333.167)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2855",
    "data-name": "Rectangle 2855",
    width: 101.648,
    height: 1.982,
    transform: "translate(1495.982 340.376)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2856",
    "data-name": "Rectangle 2856",
    width: 101.648,
    height: 1.982,
    transform: "translate(1495.982 347.584)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2857",
    "data-name": "Rectangle 2857",
    width: 101.648,
    height: 1.982,
    transform: "translate(1495.982 354.795)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43538",
    "data-name": "Path 43538",
    d: "M399.84.157c0,.02,0,.042,0,.062l.062,0Z",
    transform: "translate(1052.454 350.287)",
    fill: "#23d972"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43553",
    "data-name": "Path 43553",
    d: "M272.511,546.982l-.263-.11",
    transform: "translate(1105.85 225.678)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43564",
    "data-name": "Path 43564",
    d: "M487.109,662.18c-.095.051-.183.095-.278.139",
    transform: "translate(1079.721 211.637)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43575",
    "data-name": "Path 43575",
    d: "M371.4,508.047a10.124,10.124,0,1,1-10.123-10.123A10.124,10.124,0,0,1,371.4,508.047",
    transform: "translate(1096.242 231.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_214",
    "data-name": "Mask Group 214",
    transform: "translate(3378.725 18431.361)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83781",
    "data-name": "Group 83781",
    transform: "translate(-2505.338 -18319.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43736",
    "data-name": "Path 43736",
    d: "M405.494,436.343h0a2.28,2.28,0,0,1,2.28,2.28v27.358a2.28,2.28,0,1,1-4.56,0V438.623a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(77.128 83.465)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43737",
    "data-name": "Path 43737",
    d: "M394.969,501.412h0a2.28,2.28,0,0,1,2.28,2.28V531.05a2.28,2.28,0,0,1-4.56,0V503.692a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(75.114 95.911)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43738",
    "data-name": "Path 43738",
    d: "M405.494,501.412h0a2.28,2.28,0,0,1,2.28,2.28V531.05a2.28,2.28,0,0,1-4.56,0V503.692a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(77.128 95.911)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2925",
    "data-name": "Rectangle 2925",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83769",
    "data-name": "Group 83769",
    transform: "translate(568.393 449.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83768",
    "data-name": "Group 83768",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2926",
    "data-name": "Rectangle 2926",
    width: 51.868,
    height: 39.039,
    transform: "translate(-7.056 1.914) rotate(-15.175)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83771",
    "data-name": "Group 83771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83770",
    "data-name": "Group 83770",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43740",
    "data-name": "Path 43740",
    d: "M500.5,396.506c-12.543,0-21.279-11.019-23.368-14.249l46.167-2.85c-2.849,6.839-8.55,17.1-22.8,17.1",
    transform: "translate(91.266 72.574)",
    fill: "#f4ac94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83773",
    "data-name": "Group 83773",
    transform: "translate(555.854 380.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83772",
    "data-name": "Group 83772",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2928",
    "data-name": "Rectangle 2928",
    width: 111.724,
    height: 110.429,
    transform: "matrix(0.668, -0.744, 0.744, 0.668, -43.353, 48.265)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83775",
    "data-name": "Group 83775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83774",
    "data-name": "Group 83774",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43742",
    "data-name": "Path 43742",
    d: "M484.548,346.469c1.075.048,1.848,2.265,1.726,4.95s-1.089,4.822-2.162,4.775-1.848-2.265-1.727-4.95,1.089-4.822,2.163-4.775",
    transform: "translate(92.269 66.273)",
    fill: "#151c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43743",
    "data-name": "Path 43743",
    d: "M507.966,346.469c1.075.048,1.848,2.265,1.726,4.95s-1.089,4.822-2.162,4.775-1.848-2.265-1.727-4.95,1.089-4.822,2.163-4.775",
    transform: "translate(96.749 66.273)",
    fill: "#151c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43744",
    "data-name": "Path 43744",
    d: "M483.69,340.215a6.78,6.78,0,0,0-3.763,2.109.608.608,0,0,1-.9-.821,7.992,7.992,0,0,1,4.483-2.491c2-.3,4.215.391,6.174,2.97a.608.608,0,1,1-.969.736c-1.719-2.263-3.511-2.728-5.027-2.5",
    transform: "translate(91.599 64.835)",
    fill: "#7c4030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43745",
    "data-name": "Path 43745",
    d: "M508.857,340.215a6.78,6.78,0,0,0-3.763,2.109.608.608,0,1,1-.9-.821,7.991,7.991,0,0,1,4.483-2.491c2-.3,4.215.391,6.174,2.97a.608.608,0,1,1-.967.736c-1.72-2.263-3.512-2.728-5.028-2.5",
    transform: "translate(96.413 64.835)",
    fill: "#7c4030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43746",
    "data-name": "Path 43746",
    d: "M496.8,370.11a3.477,3.477,0,0,1-1.3-.247,2.7,2.7,0,0,1-1.68-3.24c.3-1.294.573-3.58.888-6.227.372-3.112.792-6.638,1.389-9.713a.57.57,0,1,1,1.12.218c-.59,3.033-1.008,6.538-1.376,9.629-.32,2.68-.6,5-.909,6.35a1.567,1.567,0,0,0,.995,1.926,2.607,2.607,0,0,0,3.181-1.208.57.57,0,0,1,.978.585,3.8,3.8,0,0,1-3.284,1.926",
    transform: "translate(94.443 66.992)",
    fill: "#f4ac94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43747",
    "data-name": "Path 43747",
    d: "M504.908,371.151a.608.608,0,0,1,.236.828,7.814,7.814,0,0,1-5.089,4.03,8.107,8.107,0,0,1-4.586-.262.608.608,0,0,1,.435-1.137,6.876,6.876,0,0,0,3.87.214,6.593,6.593,0,0,0,4.306-3.439.608.608,0,0,1,.828-.235",
    transform: "translate(94.7 70.98)",
    fill: "#d74848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43748",
    "data-name": "Path 43748",
    d: "M470.835,313.933c-13.223-3.648-12.349,19.569-10.259,30.778,3.191,0,6.46,8.93,7.41,12.539,2.28-4.56,2.85-16.529,3.99-23.939s8.55-7.41,24.508,3.99S531.821,343,534.1,343c1.824,0,1.14,18.239,1.14,23.368,0-10.487,5.7-21.468,7.979-21.659v-5.7c13.109-9.119,4.559-26.219,5.13-20.519.456,4.559-2.66,9.5-5.13,10.829-3.42-23.368-13.209-33.98-38.188-36.478-22.8-2.279-29.638,14.06-34.2,21.089",
    transform: "translate(87.868 55.975)",
    fill: "#4e3644"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83777",
    "data-name": "Group 83777",
    transform: "translate(546.231 400.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83776",
    "data-name": "Group 83776",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2930",
    "data-name": "Rectangle 2930",
    width: 19.093,
    height: 26.283,
    transform: "translate(-6.883 1.045) rotate(-12.109)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83779",
    "data-name": "Group 83779",
    transform: "translate(621.97 400.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83778",
    "data-name": "Group 83778",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2931",
    "data-name": "Rectangle 2931",
    width: 25.872,
    height: 27.667,
    transform: "matrix(0.796, -0.605, 0.605, 0.796, -12.012, 8.696)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83780",
    "data-name": "Group 83780",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43751",
    "data-name": "Path 43751",
    d: "M412.536,574.939V566.96H605.755v7.979L511.14,614.267Z",
    transform: "translate(78.911 108.449)",
    fill: "#28284a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43752",
    "data-name": "Path 43752",
    d: "M427.326,631.121c9.266-3.791,15.2.191,16.529,2.28,9.69-.76,24.166-1.368,4.56,15.958-24.509,21.659-54.147,1.711-66.687-5.7s2.85-18.809,8.55-18.809,24.508,11.4,37.048,6.27",
    transform: "translate(72.101 119.523)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43753",
    "data-name": "Path 43753",
    d: "M432.5,641.445c6.384-2.28,138.5-56.236,200.627-82.645,26.219-11.14,48.447,12.539,48.447,38.758s-50.726,33.058-91.764,39.327S423.385,676.213,432.5,663.674s-7.979-19.379,0-22.228",
    transform: "translate(82.312 106.349)",
    fill: "#37365a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43754",
    "data-name": "Path 43754",
    d: "M578.387,658.388c-15.047,2.736-24.508-3.8-27.358-7.41-1.9-10.45-3.306-29.98,6.269-24.508,11.97,6.839,32.489,2.85,41.608,0s19.949-.569,22.229,9.119-23.939,19.379-42.748,22.8",
    transform: "translate(105.139 119.614)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43755",
    "data-name": "Path 43755",
    d: "M347.582,584.338c2.736-16.415,20.519-25.079,29.068-27.358,8.207-1.824,20.139,2.659,25.078,5.13,39.9,16.718,125.963,51.98,151.041,59.276,31.349,9.119,53.007,18.239,43.887,18.809s.571,23.368-6.839,23.939-200.058-33.058-218.3-39.328-27.359-19.949-23.939-40.468",
    transform: "translate(66.351 106.459)",
    fill: "#4a4975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43756",
    "data-name": "Path 43756",
    d: "M410.3,431.876c6.839-10.487,46.927-21.849,66.116-26.219a53.292,53.292,0,0,1,11.4-1.139c6.839,0,3.419-3.991,3.419-9.69s3.42-3.99,9.12,0,23.368,2.85,29.638,1.709,12.539-7.979,10.829-1.709-1.709,9.119,11.4,9.69,63.267,20.519,71.246,37.617S638.284,547.579,636,560.118c-1.824,10.031-16.338,24.7-23.368,30.778-64.407.379-195.043-.342-202.338-6.27-9.119-7.41-18.239-15.389-18.809-43.888s10.259-95.754,18.809-108.863",
    transform: "translate(74.881 74.823)",
    fill: "#ff586c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43757",
    "data-name": "Path 43757",
    d: "M414.3,466.007H602.385a7.98,7.98,0,0,1,7.979,7.979V585.7a7.98,7.98,0,0,1-7.979,7.979H414.3a7.98,7.98,0,0,1-7.979-7.979V473.986a7.98,7.98,0,0,1,7.979-7.979",
    transform: "translate(77.721 89.139)",
    fill: "#e2f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43758",
    "data-name": "Path 43758",
    d: "M494.084,510.981a10.259,10.259,0,1,1-10.259,10.259,10.26,10.26,0,0,1,10.259-10.259",
    transform: "translate(92.547 97.742)",
    fill: "#194079"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2933",
    "data-name": "Rectangle 2933",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.56fc891e814ff7af4222178ca2b3b913.svg";
export { ForwardRef as ReactComponent };